import { render, staticRenderFns } from "./seclist.vue?vue&type=template&id=0f2b4716"
import script from "./seclist.vue?vue&type=script&lang=js"
export * from "./seclist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports